import { render, staticRenderFns } from "./DeliveryModal.vue?vue&type=template&id=76384bc6"
import script from "./DeliveryModal.vue?vue&type=script&lang=js"
export * from "./DeliveryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports